export function wordSpelling(word, q) {
	switch(word) {
		case 'person':
			return personWordSpelling(q)
		case 'react':
			return reactWordSpelling(q)
		case 'comment':
			return commentWordSpelling(q)
	}
}

function personWordSpelling(q) {
	switch(true) {
		case q === 1:
			return 'osoba'
		case (q % 10 >= 2 && q % 10 <= 4):
			return 'osoby'
		case q === 0 || q >= 5:
			return 'osób'
	}
}

function reactWordSpelling(q) {
	switch(true) {
		case q === 1:
			return 'zareagowała'
		case (q % 10 >= 2 && q % 10 <= 4):
			return 'zareagowały'
		case q === 0 || q >= 5:
			return 'zareagowało'
	}
}

function commentWordSpelling(q) {
	switch(true) {
		case q === 1:
			return 'komentarz'
		case (q % 10 >= 2 && q % 10 <= 4):
			return 'komentarze'
		case q === 0 || q >= 5:
			return 'komentarzy'
	}
}
